import { render } from "./ListaPedidosAbertos.vue?vue&type=template&id=1b7ac135&scoped=true"
import script from "./ListaPedidosAbertos.vue?vue&type=script&lang=js"
export * from "./ListaPedidosAbertos.vue?vue&type=script&lang=js"

import "./ListaPedidosAbertos.vue?vue&type=style&index=0&id=1b7ac135&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7ac135"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QBtn,QTable,QTd,QPagination});
